// extracted by mini-css-extract-plugin
export default {"tinyContainer":"SlideImageTiny_tinyContainer__oCB9S","backgroundOverlay":"SlideImageTiny_backgroundOverlay__szd3g","icon":"SlideImageTiny_icon__dSW-Y"};